import "./App.css";
import { AppRouter } from "./components/AppRouter/AppRouter";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import { ConfigProvider } from "./context/ConfigContext";
import { UIDProvider } from "./context/UIDContext";
import { FlowIDProvider } from "./context/FlowIDContext";
import { OpenCvProvider } from "opencv-react";
import { AmplitudeProvider } from "./context/AmplitudeContext";
import { ScanImageProvider } from "./context/ImageContext";
import { TrackerProvider } from "./context/TrackerContext";

function App() {
  return (
    <div className="App">
      <I18nextProvider i18n={i18n}>
        <OpenCvProvider openCvPath="/libs/opencv.js">
          <ConfigProvider>
            <UIDProvider>
              <FlowIDProvider>
                <ScanImageProvider>
                  <TrackerProvider>
                    <AmplitudeProvider>
                      <AppRouter />
                    </AmplitudeProvider>
                  </TrackerProvider>
                </ScanImageProvider>
              </FlowIDProvider>
            </UIDProvider>
          </ConfigProvider>
        </OpenCvProvider>
      </I18nextProvider>
    </div>
  );
}

export default App;
